export default "__VITE_ASSET__C0TK9vmJ__"